module.exports = __webpack_public_path__ + "static/6305-woodrose-20-2d7bc863fde600485e48f0e8b7b2f6ad.jpg";